import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

const isPdf = (url) => /\.pdf($|\?)/i.test(url || "");

// HO-TASK-371: comprobante opcional que se adjunta al cargar saldo a un banco o a la caja.
const MovementVoucherLink = ({ voucher }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!voucher) return null;

  const toggle = () => setIsOpen((open) => !open);

  return (
    <>
      <Button
        color="falcon-default"
        size="sm"
        className="fs--2 py-0 px-2 ml-2 align-baseline text-nowrap"
        onClick={toggle}
      >
        <FontAwesomeIcon icon={faPaperclip} className="mr-1" />
        Ver comprobante
      </Button>
      <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
        <ModalHeader toggle={toggle}>Comprobante de pago</ModalHeader>
        <ModalBody className="text-center bg-light">
          {isPdf(voucher) ? (
            <iframe
              src={voucher}
              title="Comprobante de pago"
              style={{ width: "100%", height: "70vh", border: 0 }}
            />
          ) : (
            <img
              src={voucher}
              alt="Comprobante de pago"
              style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

MovementVoucherLink.propTypes = {
  voucher: PropTypes.string,
};

export default MovementVoucherLink;
